import CostInstruction from './CostInstruction';

export default CostInstruction;
